import { Stack, StackProps, styled } from '@mui/material';

export const MapPanel = styled(Stack)<StackProps>(({ theme }) => ({
    justifyContent: 'space-between',
    flex: 1,
    padding: 0,
    overflow: 'hidden',
    alignSelf: 'stretch',
    minHeight: '100%',
    position: 'relative',
    backgroundColor: theme.color.white.main,
}));

export const Summary = styled(Stack)<StackProps>(() => ({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flexGrow: 1,
    padding: '0 16px',
}));
